var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { settlement, settlementAnalytics } from '../const/settlementAnalytics';
import { planAnalytics } from '../const/planAnalytics';
import { getCurrentRouteSection } from '.';
var analyticsEvents = {
    paymentOptions: { pageFunction: 'payment options', pageName: 'view' },
    settlement: settlementAnalytics,
    plan: planAnalytics
};
export var getAnalyticsEvent = function (_a) {
    var _b, _c, _d;
    var featureEvent = _a.featureEvent, questionId = _a.questionId, planOption = _a.planOption, currentRoute = _a.currentRoute, reEnrollAutoPay = _a.reEnrollAutoPay;
    var analyticsPage = featureEvent || questionId || '';
    var questionnaire = getCurrentRouteSection(currentRoute);
    var hasCAPSuccessPage = questionnaire === 'plan' && (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.split('.')[1]) === 'success';
    var baseResult = (_d = (_c = (_b = analyticsEvents[questionnaire]) === null || _b === void 0 ? void 0 : _b[analyticsPage]) !== null && _c !== void 0 ? _c : analyticsEvents[analyticsPage]) !== null && _d !== void 0 ? _d : {};
    var result = __assign({}, baseResult);
    if (planOption) {
        switch (planOption) {
            case 'Option1':
                result.pageSubFunction = '1payment';
                break;
            case 'Option2':
                result.pageSubFunction = '2payments';
                break;
            case 'Option3':
                result.pageSubFunction = '3payments';
                break;
            default:
                return result;
        }
    }
    if (reEnrollAutoPay) {
        result.messageType = 'your autopay was cancelled';
    }
    else if (hasCAPSuccessPage) {
        result.messageType = 'enroll in autopay';
    }
    return __assign(__assign({}, result), { pageKind: 'dch' });
};
export var getButtonAnalytics = function (currentRoute, isFooter) {
    var dataType = '';
    var currentRouteLowerCase = currentRoute.toLowerCase();
    var isSettlement = currentRouteLowerCase.slice(0, 10) === settlement;
    var isCustomer = currentRouteLowerCase.indexOf('plan') !== -1 ? 'plan' : '';
    var route = isSettlement ? settlement : isCustomer;
    switch (route) {
        case 'settlement':
            dataType = 'dch settlement';
            break;
        case 'plan':
            dataType = 'dch cap';
            break;
        default:
            dataType = 'dch';
            break;
    }
    if (isFooter) {
        dataType = "".concat(dataType, ":footer");
    }
    return {
        dataType: dataType,
        dataObject: 'button',
        dataAnalytics: 'clicktrackingevent'
    };
};
//# sourceMappingURL=getAnalytics.js.map